// extracted by mini-css-extract-plugin
module.exports = {"input":"InputText_input__dSeaY"};